import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import { isSupportedFeature, constants as features } from '@saucelabs/sl-component-supported-feature';

import manualReducer from './reducers';
import { CONFIGURATION_MOBILE_APP_TAB_URL_PATHS } from './constants';

const WebTestingContainer = () => import(/* webpackChunkName: "manual-web-testing" */ './containers/configurator/WebTestingContainer');
const MobileAppSelection = () => import(/* webpackChunkName: "manual-app-testing" */ './ducks/mobileAppSelection/components/MobileAppSelection');

const { MOBILE_REAL, MOBILE_VIRTUAL } = CONFIGURATION_MOBILE_APP_TAB_URL_PATHS;

const ManualRoutes = () => (
  <LoginRequiredContainer>
    <Switch>
      <BundleRoute
        load={WebTestingContainer}
        path="/live/web-testing/:platform?"
      />
      {isSupportedFeature(features.RDC) && (
        <Switch>
          <BundleRoute
            exact
            load={MobileAppSelection}
            path={`/live/app-testing/file/:fileId/:tab(${MOBILE_REAL}|${MOBILE_VIRTUAL})?`}
          />

          <BundleRoute
            exact
            load={MobileAppSelection}
            path={`/live/app-testing/:tab(${MOBILE_REAL}|${MOBILE_VIRTUAL})?`}
          />

          <Redirect to="/live/app-testing" />
        </Switch>
      )}
      <Redirect to="/live/app-testing" />
    </Switch>
  </LoginRequiredContainer>
);

export default dynamic(
  'apps.manual', attachReducer(manualReducer),
)(ManualRoutes);
